import { Paginated } from "src/@types/paginated";
import { Tags } from "@/enum/tags";
import { apiSlice } from "../../http";
import { IQueryFavorites, IQueryParams } from "@/@types/query";

export const FavoriteQueryInformations = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getFavorites: builder.query<Paginated<IQueryFavorites>, IQueryParams>({
      query: ({ search, meta, orderBy, perPage }) => {
        const params = new URLSearchParams({
          search,
          orderBy,
          page: meta.page.toString(),
          perPage: perPage.toString(),
        });

        return {
          url: `/query-updates/favorite-query?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: [Tags.QUERY_FAVORITES],
    }),
    createFavoriteQuery: builder.mutation<
      any,
      { query: string; query_nickname: string }
    >({
      query: ({ query, query_nickname }) => {
        console.log(query, query_nickname, "aqui");
        return {
          url: `/query-updates/favorite-query`,
          method: "POST",
          body: { query, query_nickname },
        };
      },

      invalidatesTags: [Tags.QUERY_FAVORITES],
    }),
    updateFavoriteQuery: builder.mutation<
      any,
      { id: number; query: string; query_nickname: string }
    >({
      query: ({ id, query, query_nickname }) => {
        return {
          url: `/query-updates/favorite-query`,
          method: "PATCH",
          body: { id, query, query_nickname },
        };
      },
      invalidatesTags: [Tags.QUERY_FAVORITES],
    }),
    deleteFavoriteQuery: builder.mutation<any, { id: number }>({
      query: ({ id }) => {
        return {
          url: `/query-updates/favorite-query/`,
          method: "DELETE",
          body: { id },
        };
      },
      invalidatesTags: [Tags.QUERY_FAVORITES],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetFavoritesQuery,
  useCreateFavoriteQueryMutation,
  useDeleteFavoriteQueryMutation,
  useUpdateFavoriteQueryMutation,
} = FavoriteQueryInformations;
